import { gql } from "@apollo/client";

export const GET_ALL_CRITERIOS = gql`
query GetAllCriterio {
    allCriterio{
            idCriterio,
            nombre,
            activo
      }
}`;